import api from './api';
import i18n from '@/plugins/i18n';
import router from '../../router';

//Path Regex to check if socket listener should be used
const pathRegex = /^\/adapters/;

const state = {
	adapters: [],
	loading: false,
	error: false,
	message: null,
	success: false,
	latestAdapterId: null,
	adapterRuns: [],
	limit: 10,
	page: 0,
	foundAll: false,
};
const mutations = {
	startLoading(state) {
		state.loading = true;
	},
	updateAdapter(state, { adapter }) {
		const idx = state.adapters.findIndex((a) => a.id == adapter.id);
		if (idx >= 0) {
			for (const key in adapter) {
				if (key !== 'id') {
					state.adapters[idx][key] = adapter[key];
				}
			}
		}
	},
	stopLoading(state) {
		state.loading = false;
	},
	setAdapters(state, { adapters }) {
		state.adapters = adapters;
	},
	setError(state, { message }) {
		state.error = true;
		state.message = message;
	},
	removeError(state) {
		state.error = false;
		state.message = null;
	},
	showSuccess(state, { message }) {
		state.success = true;
		state.message = message;
	},
	hideSuccess(state) {
		state.success = false;
		state.message = null;
	},
	setLatestAdapterId(state, { id }) {
		state.latestAdapterId = id;
	},
	updateOffset(state) {
		state.page += 1;
	},
	setAdapterRuns(state, { adapterRuns }) {
		state.adapterRuns = adapterRuns;
	},
	appendAdapterRuns(state, { adapterRuns }) {
		state.adapterRuns = state.adapterRuns.concat(adapterRuns);
	},
	reset(state) {
		state.page = 0;
		state.adapterRuns = [];
		state.foundAll = false;
	},
	foundAll(state) {
		state.foundAll += true;
	},
	reducePage(state) {
		state.page -= 1;
	},
	updateAdapterRun(state, { adapterRun }) {
		let adapterRunsClone = [...state.adapterRuns];
		const idx = adapterRunsClone.findIndex((run) => run.id == adapterRun.id);

		if (idx < 0) {
			//AdapterRun doesn't exists
			adapterRunsClone.push(adapterRun);
		} else {
			for (const key in adapterRun) {
				if (key === 'createdAt') {
					adapterRunsClone[idx].created = new Date(adapterRun.createdAt).toISOString().substring(0, 10);
				} else if (key === 'startedAt') {
					adapterRunsClone[idx].started = new Date(adapterRun.startedAt).toISOString().substring(11, 19);
				} else if (key === 'endedAt') {
					adapterRunsClone[idx].duration = new Date(adapterRun.endedAt) - new Date(adapterRun.startedAt);
				} else {
					//All other keys
					adapterRunsClone[idx][key] = adapterRun[key];
				}
			}
		}

		state.adapterRuns = adapterRunsClone;
	},
};

const getters = {};

const actions = {
	getAdapters({ state, commit }, showDeleted) {
		commit('startLoading');
		return api
			.getAdapters(showDeleted)
			.then((response) => {
				const adapters = response.data;
				commit('setAdapters', { adapters });
				commit('stopLoading');
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('setError', { message });
				commit('stopLoading');
				window.setTimeout(() => {
					commit('removeError');
				}, 300);
			});
	},
	getAdapter({ state, commit }, { adapterId }) {
		commit('startLoading');
		return api
			.getAdapter(adapterId)
			.then((result) => {
				commit('updateAdapter', { adapter: result.data });
				commit('stopLoading');
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('setError', { message });
				commit('stopLoading');
				window.setTimeout(() => {
					commit('removeError');
				}, 3000);
			});
	},
	deleteAdapter({ state, commit }, adapter) {
		commit('startLoading');
		var result;
		if (adapter.deleted) {
			let adapterClone = { ...adapter };
			adapterClone.deleted = false;
			result = api.editAdapter(adapterClone);
		} else {
			result = api.deleteAdapter(adapter);
		}
		return result
			.then((response) => {
				const message = i18n.t('message_saved');
				commit('stopLoading');
				commit('showSuccess', { message });
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('setError', { message });
				commit('stopLoading');
				window.setTimeout(() => {
					commit('removeError');
				}, 3000);
			});
	},
	editAdapter({ state, commit }, adapter) {
		commit('startLoading');
		return api
			.editAdapter(adapter)
			.then((response) => {
				commit('updateAdapter', { adapter });
				const message = i18n.t('message_saved');
				commit('stopLoading');
				commit('showSuccess', { message });
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('setError', { message });
				commit('stopLoading');
				window.setTimeout(() => {
					commit('removeError');
				}, 3000);
			});
	},
	createAdapter({ state, commit }, adapter) {
		commit('startLoading');
		return api
			.createAdapter(adapter)
			.then((response) => {
				const message = i18n.t('message_created');
				commit('stopLoading');
				commit('showSuccess', { message });
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('setError', { message });
				commit('stopLoading');
				window.setTimeout(() => {
					commit('removeError');
				}, 3000);
			});
	},
	loadAdapter({ state, commit }, id) {
		return api
			.loadAdapter(id)
			.then((response) => {
				const adapter = response.data;
				return adapter;
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('setError', { message });
				commit('stopLoading');
				window.setTimeout(() => {
					commit('removeError');
				}, 1500);
			});
	},
	runAdapter({ state, commit }, { id, reset }) {
		commit('startLoading');
		commit('setLatestAdapterId', { id });
		return api
			.runAdapter(id, reset)
			.then(() => {
				let message;
				if (reset) {
					message = 'Adapter reset successfull!';
				} else {
					message = 'Manual adapter run successfull!';
				}
				commit('stopLoading');
				commit('showSuccess', { message });
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('stopLoading');
				commit('setError', { message });
				window.setTimeout(() => {
					commit('removeError');
				}, 3000);
			});
	},
	getLastAdapterRun({ state, commit }, { id, limit, offset }) {
		commit('startLoading');
		return api
			.getAdapterRuns(id, limit, offset)
			.then((response) => {
				const adapterRuns = response.data;
				commit('stopLoading');
				if (!adapterRuns) {
					return null;
				}
				return adapterRuns[0];
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('stopLoading');
				commit('setError', { message });
				window.setTimeout(() => {
					commit('removeError');
				}, 3000);
			});
	},
	getAdapterRuns({ state, commit }, { id, limit, offset }) {
		commit('startLoading');
		commit('updateOffset');
		return api
			.getAdapterRuns(id, limit, offset)
			.then((response) => {
				const adapterRuns = response.data;
				if (offset == 0) {
					commit('setAdapterRuns', { adapterRuns });
				} else {
					commit('appendAdapterRuns', { adapterRuns });
				}
				commit('stopLoading');
				if (!adapterRuns) {
					return null;
				}
				return adapterRuns;
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('stopLoading');
				commit('setError', { message });
				window.setTimeout(() => {
					commit('removeError');
				}, 3000);
			});
	},
	socket_reloadAdapterRunsForAdapter({ dispatch, state, commit }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		const id = payload[0].payload.id;

		const limit = state.limit * state.page;
		commit('reducePage');
		dispatch('getAdapterRuns', { id, limit: limit, offset: 0 });
	},
	socket_updated_AdapterRun({ dispatch, state, commit }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		const adapterRun = payload[0].payload;
		commit('updateAdapterRun', { adapterRun });
	},
	socket_updated_Adapter({ dispatch, state, commit }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		const adapter = payload[0].payload;
		commit('updateAdapter', { adapter: adapter });
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
